import { render } from "./Recipe_Insert.vue?vue&type=template&id=6aa81ef4"
import script from "./Recipe_Insert.vue?vue&type=script&lang=js"
export * from "./Recipe_Insert.vue?vue&type=script&lang=js"

import "./Recipe_Insert.vue?vue&type=style&index=0&id=6aa81ef4&lang=scss"

import exportComponent from "/home/los7/Documents/Sites/IntendedMe/Front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__